"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_comment__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d31b4806-9758-4160-a8cb-75cc6e1ea63e",
    "data-name": "Ebene 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "comments-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,32h-128a16,16,0,0,0-16,16v72a16,16,0,0,0,16,16H40v32l32-32h87.75a16,16,0,0,0,16-16V48A16,16,0,0,0,159.75,32Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e9e3a911-688a-44c9-af55-30a38d25741e",
    "data-name": "1417ec32-e729-46f5-a5dd-cb4e9bb346aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,60H44a2,2,0,0,1,0-4H148a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "07c4dfd9-f6b8-4b60-acf5-1678de873364",
    "data-name": "37ff003d-6f37-46f8-a592-0a0670165f1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,84H44a2,2,0,0,1,0-4H148a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2d1ce1dd-4f36-4cae-a159-405bbcea5e1a",
    "data-name": "47a7c834-8178-4002-899f-93d3e6ac43c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,108H44a2,2,0,1,1,0-4H148a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,134H31.75a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H40Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,134H72L40,166v2l32-32h87.75a16,16,0,0,0,16-16v-2A16,16,0,0,1,159.75,134Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_comment__dark;
exports.default = _default;